import formatMoney from '../../currency/formatMoney';
export default function formatCents(locale, cents, options = {}) {
    const precision = options.precision ?? (cents % 100 ? 2 : 0);
    return formatMoney(locale, cents / 100, { ...options, precision });
}
//# sourceMappingURL=formatCents.js.map